import { render, staticRenderFns } from "./ScratchCard.vue?vue&type=template&id=894e6b0a&scoped=true"
import script from "./ScratchCard.vue?vue&type=script&lang=js"
export * from "./ScratchCard.vue?vue&type=script&lang=js"
import style0 from "./style.scss?vue&type=style&index=0&id=894e6b0a&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "894e6b0a",
  null
  
)

export default component.exports